import React from "react";
import PhanTrang from "components/CommonComponent/PhanTrang";
import ContentTable from "./ContentTable";
import BtnThemMoi from "./ThemMoi/BtnThemMoi";

export const TableDanhSach = ({ phanQuyen, listDanhSach, isLoading, dataSearch, setDataSearch, onSearch, onReload }) => {
  const handlePageChange = (pageNumber) => {
    setDataSearch(prev => ({ ...prev, PageIndex: pageNumber }));
    onSearch({ ...dataSearch, PageIndex: pageNumber });
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  };

  const handlePageSizeChange = (pageSize) => {
    setDataSearch(prev => ({ ...prev, PageSize: pageSize, PageIndex: 1 }));
    onSearch({ ...dataSearch, PageSize: pageSize, PageIndex: 1 });
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  };

  return (
    <>
      {isLoading ? (
        <div className="loading-page1">
          <div className="loader loader-default is-active"></div>
        </div>
      ) : (
        <>
          <div className="card border-light mb-2 card-v2">
            <div className="card-body card-body-v2">
              <div className="row col-sm-12 col-md-12 themoi-taisanthanhly mb-1">
                <div className="col-sm-12 col-md-10">
                  {phanQuyen.themmoi && <BtnThemMoi onReload={onReload} />}
                </div>
              </div>
              <div className="Left808x200 Table-main-new css-table-ds">
                <div className="table-mobile table-mobile-hover">
                  <div className="custom-table-wrapper" style={{ overflowX: "auto", width: '100%' }}>
                    <div className="table-headers">
                      <div className="custom-table-header flex-basis-5 text-left" style={{ justifyContent: 'flex-start' }}>
                        <p className="color-do-bold">
                          STT
                          <br />[{listDanhSach.iTotal}]
                        </p>
                      </div>
                      <div className="custom-table-header flex-basis-70 text-center" style={{ justifyContent: 'flex-center' }}>
                        <p>Tên hợp đồng</p>
                      </div>
                      <div className="custom-table-header flex-basis-25 text-center">
                        <p>Chức năng</p>
                      </div>
                    </div>

                    <div className="custom-table-body">
                      <ContentTable 
                        listDanhSach={listDanhSach.List}
                        phanQuyen={phanQuyen}
                        onReload={onReload}
                        PageIndex={dataSearch.PageIndex}
                        PageSize={dataSearch.PageSize}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="card border-light mb-2 card-v2" >
            <div className="card-body card-body-v2">
              <PhanTrang
                pageIndex={dataSearch.PageIndex}
                pageSize={dataSearch.PageSize}
                totalCount={listDanhSach.iTotal}
                onPageChange={handlePageChange}
                onPageSizeChange={handlePageSizeChange}
              />
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default TableDanhSach;